;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"uW3iXChCwhoaYQrapdj9p"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { ENVIRONMENT_INSTANCES, getCurrentEnvironment, shouldEnableSentry } from '@/utils/common/environment';
import { init, replayIntegration } from '@sentry/nextjs';

const env = getCurrentEnvironment();

init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Tags every event with the instance (dev / uat / prod) so you can filter in the Sentry dashboard
  environment: env,

  // Disable Sentry in local development
  enabled: shouldEnableSentry(),

  integrations: [replayIntegration()],

  // Lower sample rate in prod to control quota; full tracing in dev/uat
  tracesSampleRate: env === ENVIRONMENT_INSTANCES.PROD ? 0.1 : 1,

  // Sample 10% of sessions normally; 100% when an error occurs
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  debug: false,
});
